import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, output } from '@angular/core';
import { CONSTANTS_DATA } from '@fitness-force/constants';

import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'trial-type',
  templateUrl: './trial-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class TrialTypeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>(); // {type:actionName,columnData }

  getTrialType(activeTrial: any) {
    const typeKey = activeTrial?.trial_type ?? activeTrial?.type;
    return CONSTANTS_DATA.TRIALS_TYPE.find((item) => item.key === typeKey)?.name;
  }

  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }
}
